

// export const AXIOS_IP_REPORTCARD = 'http://192.168.111.7:8222/beilun/admin-api'
export const AXIOS_IP_REPORTCARD = window.location.origin +  `/supervise_cdc_proxy/beilun/admin-api`


export const convertToLabelValue = (data: any) => {
  if (!Array.isArray(data)) return [];
  
  const processNode = (node :any) => {
    // 创建当前节点的 label-value 对象
    const item = {
      label: node.diseaseName,
      value: node.id,
      children: null
    };
    
    // 如果有子节点，递归处理
    if (node.children && Array.isArray(node.children)) {
      item.children = node.children.map(processNode);
    }
    
    return item;
  };
  
  return data.map(processNode);
}